import Container from './Container';
import * as mat4 from './glMatrix/mat4';
import * as vec3 from './glMatrix/vec3';
import VirtualTexture from './VirtualTexture'

const stats = {
	frustumChecks: 0,
	drawCalls: 0,
	drawCallsNames:{},
	vertices: 0,
	faces: 0,
}

const settings = {
	debug: false,
	useVirtualTexture: false,
	useVirtualTexture: false,
}

// let $statsCanvas = document.createElement('canvas')
// let statsCtx = $statsCanvas.getContext('2d')
// $statsCanvas.id  = 'stats-canvas';
// $statsCanvas.width  = 150
// $statsCanvas.height = 60
// $statsCanvas.style.position = 'fixed'
// $statsCanvas.style.right = 0
// $statsCanvas.style.top = 0
// $statsCanvas.style.pointerEvents = 'none'
// $statsCanvas.style.zIndex = 100000000
// document.body.appendChild( $statsCanvas )
// function updateStats() {
// 	requestAnimationFrame( updateStats )
// 	statsCtx.fillStyle = '#ff0000'
// 	statsCtx.fillRect( 0, 0, $statsCanvas.width, $statsCanvas.height  )
// 	statsCtx.font = '12px sans-serif'
// 	statsCtx.textAlign = 'left'
// 	statsCtx.fillStyle = '#fff'
// 	statsCtx.fillText('drawcalls: '+stats.drawCalls, 10, 12)
// 	statsCtx.fillText('frustumChecks: '+stats.frustumChecks, 10, 12+12)
// 	statsCtx.fillText(`vertices: ${stats.vertices}`, 10, 12+24)
// 	statsCtx.fillText(`faces: ${stats.faces}`, 10, 12+24+12)
// 	stats.drawCallsNames = {}
// 	stats.drawCalls = 0;
// 	stats.frustumChecks = 0;
// 	stats.vertices = 0;
// 	stats.faces = 0;
// 	console.log('updateStats');
// }

// if (settings.debug) {
// 	updateStats()
// }

// window.getStats = function() {
// 	return stats.drawCallsNames;
// }

let _scale = vec3.create()

let vv = vec3.create()
let p = vec3.create()
let cameraDirection = vec3.create()
let cameraPosition = vec3.create()
let diff = vec3.create();
let minWorldBound = vec3.create()
let maxWorldBound = vec3.create()

class Mesh extends Container {

	constructor(options) {
		super();
		this.material  = null;
		this.geometry = null;
		this.options = options || {};
		this._viewMatrix = mat4.create()
		this._invViewMatrix = mat4.create()
		this._modelViewMatrix = mat4.create()
		this.uniforms = {}
		this.bSphere = {center:vec3.create(),radius:0}
	}

	updateWorldMatrix() {
		if (this.geometry) {
			super.updateWorldMatrix()
			this.geometry._bSphere = this.geometry._bSphere || this.geometry.getBoundingSphere()
			vec3.copy( this.bSphere.center, this.geometry._bSphere.center)
			vec3.transformMat4( this.bSphere.center, this.bSphere.center, this.worldMatrix)
			mat4.getScaling(_scale, this.worldMatrix)
			this.bSphere.radius = this.geometry._bSphere.radius *  Math.max(_scale[0], Math.max(_scale[1], _scale[2]));
		}
	}

	render(camera, options={}) {

		let material = options.overrideMaterial || this.material;

		if (camera && material && 
			this.geometry //TODO: check for geometry.length
			) {

			
			if (!this.visible) {
				return
			}

			super.render( camera, options );
			
			if (!this.keep  && camera.frustum && (this.boudingBox || this.bSphere)) {
				stats.frustumChecks++;
				if ( !camera.frustum.intersectsSphere(this.bSphere) ){
					return;
				}
			}

			// if (this.options.beforeRender) {
			// 	this.options.beforeRender() 
			// }

			if (settings.debug) {
				stats.drawCalls++;
				stats.drawCallsNames[ (this.id||this.name) ] = stats.drawCallsNames[ (this.id||this.name) ] || 0
				stats.drawCallsNames[ (this.id||this.name) ]++
			}

			//predefined uniforms
			mat4.copy(this._viewMatrix, camera.inverseWorldMatrix);
			mat4.multiply(this._modelViewMatrix, this._viewMatrix, this.worldMatrix);

			if (material.uniforms['uCameraPosition'] !== void 0) {
				material.uniforms['uCameraPosition'].value  = camera.position;
			}
			if (material.uniforms['uVMatrix'] !== void 0) {
				material.uniforms['uVMatrix'].value  = this._viewMatrix;
			}
			if (material.uniforms['uNormalMatrix'] !== void 0) {
				material.uniforms['uNormalMatrix'].value  = this._normalMatrix
			}
			if (material.uniforms['uMMatrix'] !== void 0) {
				material.uniforms['uMMatrix'].value  = this.worldMatrix;
			}
			if (material.uniforms['uMVMatrix'] !== void 0) {
				material.uniforms['uMVMatrix'].value = this._modelViewMatrix;
			}
			if (material.uniforms['uPMatrix'] !== void 0) {
				material.uniforms['uPMatrix'].value = camera.projectionMatrix;
			}
			
			//Scene uniforms
			let contextUniformsKeys = Object.keys( options.uniforms );
			for (let i =0; i<contextUniformsKeys.length; i++) {
				if (material.uniforms[ contextUniformsKeys[i] ] !== void 0) {
					material.uniforms[ contextUniformsKeys[i] ].value = options.uniforms[ contextUniformsKeys[i] ];
				}
			}

			//Mesh uniforms
			let meshUniformsKeys = Object.keys( this.uniforms );
			for (let i =0; i<meshUniformsKeys.length; i++) {
				if (material.uniforms[ meshUniformsKeys[i] ] !== void 0) {
					material.uniforms[ meshUniformsKeys[i] ].value = this.uniforms[ meshUniformsKeys[i] ];
				}
			}
			
			for (let k in options.defines) {
				if (material.defines[ k ] !== options.defines[ k ]) {
					material.defines[ k ] = options.defines[ k ];
				}
			}

			// if (this.twoSided && material.gl) {
			// 	let savedState = material.gl.getParameter(material.gl.CULL_FACE_MODE);
			// 	material.gl.disable(material.gl.CULL_FACE);
			// 	material.draw( this.geometry );
			// 	if ( savedState == material.gl.BACK  
			// 		|| savedState == material.gl.FRONT
			// 		){
			// 		material.gl.cullFace(savedState);
			// 		material.gl.enable(material.gl.CULL_FACE);
			// 	}
			// }
			
			if (material.gl) {
				if (this.backSided) {
					if (!material.gl.IS_FRONT_CULLING) {
						material.gl.IS_FRONT_CULLING = true
						material.gl.cullFace(material.gl.FRONT);
						material.gl.enable(material.gl.CULL_FACE);
					}
				}
				else {
					if (material.gl.IS_FRONT_CULLING) {
						material.gl.IS_FRONT_CULLING = false
						material.gl.disable(material.gl.CULL_FACE);
					}
				}
			}
			
			// 	material.draw( this.geometry );

			// 	if ( savedState == material.gl.BACK  
			// 		|| savedState == material.gl.FRONT
			// 		){
			// 		material.gl.cullFace(savedState);
			// 		material.gl.enable(material.gl.CULL_FACE);
			// 	}
			// }

			if (settings.debug) {
				if (this.geometry.attributes['instanceMatrix']) {
					let n = this.geometry.attributes['instanceMatrix'].data.length/16
					// console.log('NUM_INSTANCES', n, this.geometry.attributes.position.data.length/3 )
					stats.vertices += (this.geometry.attributes.position.data.length/3) * n
					stats.faces += (this.geometry.attributes.index ? this.geometry.attributes.index.data.length/3 : (this.geometry.attributes.position.data.length/3 / 3)) * n
				}
				else {
					stats.vertices += this.geometry.attributes.position.data.length/3
					stats.faces += this.geometry.attributes.index ? this.geometry.attributes.index.data.length/3 : (this.geometry.attributes.position.data.length/3 / 3)
				}
			}


			
			// else {


				if (material.uniforms.uLightmapTileIndex && settings.isVirtualTexturePass && settings.useVirtualTexture) {
					let tile = VirtualTexture.getTile(this);
					material.uniforms.uLightmapTileIndex.value = tile.index;
				}

				console.timeStamp("Mesh.draw:" + this.name);
				
				material.draw( this.geometry );

			// }


		}

	}

} 

export default Mesh;